export default "__VITE_PUBLIC_ASSET__c05922c5__"